import {apiTemplate} from "@/core/helpers/api.js";

export class Docs {
  static async getDocs(doc) {
    const userLocale = localStorage.getItem('gift-digital-user-locale');

    const response = await apiTemplate(
      {
        "Content-Type": "application/json",
        "Accept-language": userLocale ? userLocale : 'en-gb'
      },
      `query {
        posts(slug: "${doc}") {
          edges {
            node {
              content
            }
          }
        }
      }`
    );

    return await response;
  }
}